import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import giardinoImg from '@/assets/destinations/giardino.jpg';
import productsImg from '@/assets/destinations/products.jpg';
import tourismImg from '@/assets/destinations/tourism.jpg';
import { localizedTo } from '@/composables/useLocalizedRoute';
export default defineComponent({
    name: 'Portfolio',
    setup() {
        const { t } = useI18n();
        const categories = computed(() => [
            {
                value: 'hotels',
                label: t('portfolio.categoryLabels.hotels'),
                tagline: t('portfolio.categoryTaglines.hotels'),
                image: giardinoImg,
                delay: 0,
            },
            {
                value: 'tourism',
                label: t('portfolio.categoryLabels.tourism'),
                tagline: t('portfolio.categoryTaglines.tourism'),
                image: tourismImg,
                delay: 80,
            },
            {
                value: 'products',
                label: t('portfolio.categoryLabels.products'),
                tagline: t('portfolio.categoryTaglines.products'),
                image: productsImg,
                delay: 160,
            },
        ]);
        return { categories, localizedTo };
    },
});
